<style lang="scss" scoped="">
  @import "../../../assets/scss/mixins";

  .content-part {
    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
      padding-left: 25px;
      padding-right: 25px;
    }
  }

  .batch-info {
    .oms-row {
      margin-bottom: 10px;
    }
  }
</style>
<template>
  <div class="content-part">
    <div class="content-right content-padding">
      <h3>设备列表</h3>
      <el-table :data="devList" class="header-list border-black" border
              style="width: 100%">
        <el-table-column prop="devNo" label="设备编码" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="temperature" label="最新温度数据" :sortable="true"  min-width="150">
          <span slot-scope="{row}">{{row.temperature}}℃</span>
        </el-table-column>
        <el-table-column prop="humidity" label="最新湿度数据" :sortable="true" min-width="150">
          <span slot-scope="{row}">{{row.humidity}}%</span>
        </el-table-column>
        <el-table-column prop="collectTime" label="采集时间" :sortable="true"  min-width="150">
          <span slot-scope="{row}" v-if="row.collectTime">{{row.collectTime | time}}</span>
        </el-table-column>
        <el-table-column prop="insertTime" label="插入数据库时间" :sortable="true"  min-width="150">
          <span slot-scope="{row}" v-if="row.insertTime">{{row.insertTime | time}}</span>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import MethodsMix from '@/mixins/methodsMinix';

  export default {
    name: 'editForm',
    mixins: [MethodsMix],
    props: {
      show: Boolean,
      currentItem: Object
    },
    data: function () {
      return {
        devList: []
      };
    },
    watch: {
      show(val) {
        this.devList = [];
        if (!val) return;
        this.queryDevList();
      }
    },
    methods: {
      queryDevList() {
        if (!this.currentItem.id) return;
        this.$http.post(`/bsp-warehouse-data/relation/${this.currentItem.id}`).then(res => {
          res.data.forEach(i => {
            let data = i.devData || {};
            i.temperature = data.temperature;
            i.humidity = data.humidity;
            i.collectTime = data.collectTime;
            i.insertTime = data.insertTime;
          });
          this.devList = res.data;
        });
      },
      doClose: function () {
        this.$emit('close');
      }
    }
  };
</script>
